<style lang="css" scoped>

</style>

<template>

  <v-flex d-flex nowrap row shrink class="modeBtns">
    <v-btn class="btn-off" :loading="loading === 2" :outline="btnMode !== 2" color="red" icon medium @click="changeMode(2)">
        <v-icon medium class="px-2" :color="btnMode === 2 ? 'white' : 'red lighten-3'">flash_off</v-icon>
    </v-btn>
    <v-btn class="btn-auto" :loading="loading === 0" :outline="btnMode !== 0" color="blue" icon medium @click="changeMode(0)">
        <v-icon medium class="px-2" :color="btnMode === 0 ? 'white' : 'blue lighten-3'">flash_auto</v-icon>
    </v-btn>
    <v-btn class="btn-on" :loading="loading === 1" :outline="btnMode !== 1" color="green" icon medium @click="changeMode(1)">
        <v-icon medium class="px-2" :color="btnMode === 1 ? 'white' : 'green lighten-3'">flash_on</v-icon>
    </v-btn>
  </v-flex>

</template>

<script>

import { mapGetters } from 'vuex'
export default {
    props: ['slug'],
    data() {
        return {
          // btnMode: null,
          loading: null,
        }
    },
    created() {
      // this.btnMode = this.mode;
      // EventBus.$on('updateItemsBus', data => {
      //   if (data.modified && data.modified === this.slug) {
      //     this.btnMode = data.items[this.slug].data.mode;
      //     this.loading = null;
      //   }
      // });
    },
    computed: {
       ...mapGetters(['devices/device']),
      btnMode: function (getter) {
        this.loading = null
        return getter['devices/device'](this.slug).data.mode;
      }
    },
    watch: {
      // slug(){
      //   this.btnMode = this.mode;
      // },
      // btnMode(){
      //   this.btnMode = this.mode;
      // },
    },
    methods: {
      changeMode(mode){
        if (this.mode !== mode) {
          this.loading = mode;
          let data = {
            slug: this.slug,
            modify:{
              parameter: 'mode',
              value: mode,
            }
          }
          this.$store.dispatch('devices/modifyDevice', data);
          // this.$emit('modifyItemEvent', data);
        }
      }
    }
}

</script>
